import { makeAutoObservable } from "mobx";

type SubScreens =
  | "Dashboard"
  | "Players"
  | "Controllers"
  | "Tournaments"
  | "Accounting";

class PortalStore {
  activeScreen: SubScreens = "Dashboard";
  portalHeight: number = window.innerHeight;
  navbarHeight: number = 0;
  bottomStatusBarHeight: number = 0;
  constructor() {
    makeAutoObservable(this);
    this.portalHeight = window.innerHeight;
  }

  public switch(sub: SubScreens) {
    this.activeScreen = sub;
  }
}

export const portalStore = new PortalStore();
